import { IApplicationState } from '../../types/redux';

export const selectNewbuildingBlackFridayMainPageImage = (state: IApplicationState): string => {
  return state.newbuildingBlackFriday.mainPageImage ?? '';
};
